export const BASE_URL = 'https://api.phoenix.wegroup.be/';
export const API_KEY = 'AIzaSyA8abV3EfUnH2I1TH54KO0dERmUxy2CRKM';
export const CAPTCHA_KEY = '6LfXtssUAAAAAHPd30jLlGBYw2BjuyOu_QAqcRDq';
